<style scoped>
    .btn{
        cursor: pointer;
    }
    .dir-path{
        font-size: 14px;
        margin: 7px;
    }
    .dir-path-item{
        display: inline-block;
        vertical-align: top;
    }
    .dir-path-item-text{
        cursor: pointer;
    }
    .dir-path-item-text:hover{
        color: #000;
    }
    .dir-path-item-text-active{
        cursor: auto;
    }
    .dir-path-item-text-active:hover{
        color: #495060;
    }
    .item{
        position: relative;
        display: inline-block;
        vertical-align: top;
        width: 100px;
        text-align: center;
        word-break: break-all;
        line-height: 12px;
        padding: 10px;
        margin: 10px 0;
        cursor: pointer;
    }
    .item:hover{
        background: #f5f5f5;
        box-shadow: inset 0 0 1px #ddd;
        border-radius: 6px;
    }
    .item-setting{
        position: absolute;
        bottom: 3px;
        right: 3px;
        font-size: 18px;
        display: none;
    }
    .item:hover .item-setting{
        display: inline-block;
    }
    .item-size{
        display: none;
        position: absolute;
        top: 3px;
        left: 3px;
        font-size: 10px;
        color: #aaa;
    }
    .item:hover .item-size{
        display: inline-block;
    }
    .item-setting-item{
        padding: 6px 12px;
        cursor: pointer;
    }
    .item-setting-item:hover{
        background: #dddee1;
    }
    .item-setting-item-separator{
        display: block;
        width: 100%;
        height: 1px;
        background: #dddee1;
        margin: 2px 0;
    }
    .item-share-qty{
        display: inline-block;
        position: absolute;
        top: 35px;
        left: 50%;
        transform: translateX(-50%);
        color: #aaa;
    }
    .item-share-qty-block{
        top: 29px;
        line-height: 8px;
    }
    .item-share-qty-block .item-share-qty-text{
        display: block;
    }
    .search-item, .share-customer{
        padding: 6px 12px;
        cursor: pointer;
    }
    .search-item:hover, .share-customer:hover{
        background: #dddee1;
    }
    .search-item-selected{
        cursor: auto;
        background: #dddee1;
        color: #aaa;
    }
    .search-item-hover-text, .share-customer-hover-text{
        display: none;
        float: right;
        color: #aaa;
    }
    .search-item:hover .search-item-hover-text, .share-customer:hover .share-customer-hover-text{
        display: inline-block;
    }
    .footer-item{
        display: inline-block;
    }
</style>
<style>
    .file-desktop .ivu-poptip-body{
        padding: 8px 0;
    }
</style>
<template>
  <div class="file-desktop">
    <Row>
      <i-col span="4">
        <Dropdown
          trigger="click"
          placement="bottom-start"
          @on-click="selectNew"
        >
          <i-button icon="md-add">
            新建
          </i-button>
          <DropdownMenu slot="list">
            <DropdownItem name="file">
              文件
            </DropdownItem>
            <DropdownItem name="dir">
              文件夹
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </i-col>
      <i-col span="20">
        <div class="dir-path">
          <div
            class="dir-path-item"
            @click="goToDir(-1)"
          >
            <span
              class="dir-path-item-text"
              :class="{'dir-path-item-text-active': !dir_path.length}"
            >
              我的桌面
            </span>
          </div>
          <div
            v-for="(dir, index) in dir_path"
            :key="dir.id"
            class="dir-path-item"
            @click="goToDir(index)"
          >
            <span class="dir-path-item-separator">/</span>
            <span
              class="dir-path-item-text"
              :class="{'dir-path-item-text-active': (index+1) === dir_path.length}"
            >
              {{ dir.name }}
            </span>
          </div>
        </div>
        <div class="hr" />
        <div class="line">
          <div
            v-for="(file, index) in files"
            :key="file.id"
            class="file-item item"
            @click="loadDir(file)"
          >
            <Icon
              v-if="file.is_dir"
              type="ios-folder-outline"
              size="50"
            />
            <Icon
              v-else
              type="ios-document-outline"
              size="50"
              color="#aaa"
            />
            <div class="line">
              {{ file.name }}
            </div>
            <div
              v-if="file.share_qty > 0"
              class="item-share-qty"
              :class="{'item-share-qty-block': !file.is_dir}"
            >
              <Icon type="md-people" />
              <span class="item-share-qty-text">{{ file.share_qty + 1 }}</span>
            </div>
            <div
              v-if="!file.is_dir"
              class="item-size"
            >
              {{ getFileSize(file) }}
            </div>
            <div
              class="item-setting"
              @click.stop=""
            >
              <Poptip
                trigger="click"
                placement="bottom"
              >
                <Icon type="md-settings" />
                <div slot="content">
                  <div
                    class="item-setting-item"
                    @click.stop="editFile(file)"
                  >
                    <Icon type="md-create" />
                    <span>编辑</span>
                  </div>
                  <div
                    v-if="!file.is_dir"
                    class="item-setting-item"
                    @click.stop="uploadFile(file)"
                  >
                    <Icon type="ios-cloud-upload" />
                    <span>重新上传</span>
                  </div>
                  <div
                    v-if="!file.is_dir"
                    class="item-setting-item"
                    @click.stop="downloadFile(file)"
                  >
                    <Icon type="md-arrow-down" />
                    <span>下载</span>
                  </div>
                  <div
                    class="item-setting-item"
                    @click.stop="shareFile(file)"
                  >
                    <Icon type="md-share" />
                    <span>共享</span>
                  </div>
                  <div class="item-setting-item-separator" />
                  <div
                    class="item-setting-item"
                    @click.stop="delFile(file, index)"
                  >
                    <Icon type="ios-trash" />
                    <span>删除</span>
                  </div>
                </div>
              </Poptip>
            </div>
          </div>
        </div>
        <div
          v-if="empty"
          class="line"
        >
          <span>没有内容</span>
        </div>
        <Backdrop v-show="loading" />
      </i-col>
    </Row>

    <Modal
      v-model="upload_file_config.modal"
      width="600"
      title="添加/编辑 文件"
      ok-text="关闭"
      cancel-text=""
      :closable="false"
      :mask-closable="false"
    >
      <div class="line">
        <Upload
          ref="uploader"
          type="drag"
          :max-size="file_max_size"
          :on-exceeded-size="exceededSize"
          :on-progress="uploadFileProgress"
          :on-success="uploadFileOk"
          :on-error="uploadFileFail"
          :data="edit_file"
          :action="file_upload_path"
        >
          <div style="padding: 20px 0">
            <Icon
              type="ios-cloud-upload"
              size="52"
              style="color: #3399ff"
            />
            <p>点击或拖拽上传文件</p>
          </div>
        </Upload>
      </div>
      <div slot="footer">
        <div
          v-if="uploading"
          class="footer-item"
        >
          <Spin />处理中
        </div>
        <Button
          v-else
          type="primary"
          @click="closeUploadModal"
        >
          关闭
        </Button>
      </div>
    </Modal>
    <Modal
      v-model="edit_file_config.modal"
      width="600"
      title="添加/编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_file_config.loading"
      @on-ok="editFileOk"
    >
      <div class="line">
        <Form
          :model="edit_file"
          :label-width="80"
        >
          <FormItem label="名称">
            <i-input
              v-model="edit_file.name"
              placeholder="名称..."
            />
          </FormItem>
          <FormItem label="备注">
            <i-input
              v-model="edit_file.desc"
              type="textarea"
              placeholder="备注..."
            />
          </FormItem>
        </Form>
      </div>
    </Modal>
    <Modal
      v-model="set_share_config.modal"
      ok-text="关闭"
      cancel-text=""
      width="600"
      :title="'共享: ' + edit_file.name"
      :mask-closable="false"
    >
      <div class="line">
        <Row>
          <i-col span="12">
            <div class="line">
              已共享用户
            </div>
            <div class="line">
              <div
                v-for="(customer, index) in share_customers"
                :key="customer.id"
                class="share-customer"
                @click="deleteCustomerFromShares(customer, index)"
              >
                <span>{{ customer.account }} - </span>
                <span>{{ customer.team_name }} - </span>
                <span>{{ customer.uid }}</span>
                <span class="share-customer-hover-text">点击删除</span>
              </div>
            </div>
          </i-col>
          <i-col span="12">
            <div class="line">
              搜索你要共享的用户
            </div>
            <i-input
              v-model="search_customer_text"
              @on-enter="searchCustomer"
            >
              <i-button
                slot="append"
                icon="ios-search"
                @click="searchCustomer"
              />
            </i-input>
            <div class="line">
              <div
                v-for="customer in search_customer_results"
                :key="customer.id"
                class="search-item"
                @click="addCustomerToShares(customer)"
              >
                <span>{{ customer.account }} - </span>
                <span>{{ customer.team_name }} - </span>
                <span>{{ customer.uid }}</span>
                <span class="search-item-hover-text">点击添加</span>
              </div>
            </div>
          </i-col>
        </Row>
      </div>
    </Modal>
  </div>
</template>
<script route="/file/desktop">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: '/file/desktop',
    /* router_info_end */
    data() {
      return {
        file_upload_path: Util.api.file_upload_path,
        file: null,
        file_max_size: 1024 * 20, //50mb
        new_file: {
          bfile_id: 0,
          name: '',
          desc: '',
          is_dir: false
        },
        edit_file: {},
        files: [],
        dir_path: [],
        upload_file_config: {
          modal: false,
          loading: true
        },
        edit_file_config: {
          modal: false,
          loading: true
        },
        set_share_config: {
          modal: false,
          loading: true
        },
        loading: false,
        uploading: false,
        share_customers: [],
        search_customer_text: '',
        search_customer_results: []
      }
    },
    computed: {
      curDir() {
        const len = this.dir_path.length;
        return this.dir_path[len - 1] || {};
      },
      empty() {
        return !this.files.length;
      }
    },
    created() {
      this.getDirAndFile();
    },
    mounted() {
      //
    },
    methods: {
      getDirAndFile() {
        if (this.loading) {
          return;
        }
        this.loading = true;
        Util.ajax.get(Util.api.query_dir_and_file, {
          params: this.curDir
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          this.files = [];
          if (res.code === 1) {
            const data = res.data;
            data.files.forEach((file) => {
              if (file.id) {
                this.files.push(file);
              }
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.loading = false;
          console.log(e);
        });
      },
      goToDir(index) {
        if (index === this.dir_path.length - 1) {
          return;
        }
        const len = this.dir_path.length;
        this.dir_path.splice(index + 1, len - (index - 1));
        this.$nextTick(() => {
          this.getDirAndFile();
        });
      },
      loadDir(file) {
        if (file.is_dir) {
          this.dir_path.push(file);
          this.$nextTick(() => {
            this.getDirAndFile();
          });
        }
      },
      selectNew(name) {
        switch (name) {
        case 'file':
          this.uploadFile(this.new_file);
          break;
        case 'dir':
          this.editFile(this.new_file, true);
          break;
        default:
          this.$Message.error('未定义行为');
          break;
        }
      },
      uploadFile(file) {
        this.edit_file = Util.clone(file);
        if (!this.edit_file.bfile_id) {
          this.edit_file.bfile_id = this.curDir.id;
        }
        this.upload_file_config.modal = true;
        document.body.click();
      },
      closeUploadModal() {
        this.upload_file_config.modal = false;
      },
      uploadFileProgress(ev, file, fileList) {
        this.uploading = true;
        console.log(ev);
      },
      uploadFileOk(data, file, fileList) {
        console.log(data);
        this.uploading = false;
        if (data.code === 1) {
          this.upload_file_config.modal = true;
          this.$refs.uploader.clearFiles();
          this.insertFile(data.file);
          this.$Modal.success({
            title: '提示',
            content: '上传成功!'
          });
        } else {
          this.$Modal.error({
            title: '提示',
            content: data.msg
          });
        }
      },
      uploadFileFail(error, file, fileList) {
        this.uploading = false;
        this.$Modal.error({
          title: '上传失败',
          content: error
        });
      },
      handleUpload(file) {
        this.file = file;
        return false;
      },
      exceededSize(file, fileList) {
        this.$Modal.error({
          title: '提示',
          content: `文件大小超出限制(最大${this.file_max_size / 1024}MB)`
        });
      },
      editFile(file, is_dir) {
        this.edit_file = Util.clone(file);
        if (is_dir) {
          this.edit_file.is_dir = true;
        }
        if (!this.edit_file.bfile_id) {
          this.edit_file.bfile_id = this.curDir.id;
        }
        this.edit_file_config.modal = true;
        document.body.click();
      },
      delFile(file, index) {
        if (this.loading) {
          return;
        }
        this.$Modal.confirm({
          title: '提示',
          content: '你确定要删除吗?',
          onOk: () => {
            const curDir = this.curDir;
            this.loading = true;
            Util.ajax.post(Util.api.delete_file, {
              id: file.id
            }).then((response) => {
              return response.data;
            }).then((data) => {
              this.loading = false;
              if (data.code === 1) {
                if (curDir.id === this.curDir.id) {
                  this.files.splice(index, 1);
                }
                this.$Message.success('操作成功!');
              } else {
                this.$Modal.error({
                  title: '提示',
                  content: data.msg
                });
              }
            }).catch((e) => {
              this.loading = false;
              this.$Message.error('删除失败!');
              console.log(e);
            });
          }
        });
        document.body.click();
      },
      editFileOk() {
        Util.ajax.post(Util.api.update_file, this.edit_file).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.edit_file_config.modal = false;
            this.insertFile(data.file);
            this.$Message.success('操作成功!');
          } else {
            this.edit_file_config.loading = false;
            setTimeout(() => {
              this.edit_file_config.loading = true;
            }, 500);
            this.$Modal.error({
              title: '提示',
              content: data.msg
            });
          }
        }).catch((e) => {
          this.edit_file_config.loading = false;
          setTimeout(() => {
            this.edit_file_config.loading = true;
          }, 500);
          console.log(e);
        });
      },
      insertFile(file) {
        if (!this.curDir.id || this.curDir.id === file.bfile_id) {
          Util.insertOrUpdateArrayItem(this.files, file);
        }
      },
      downloadFile(file) {
        Util.ajax.get(Util.api.download_file, {
          params: {
            id: file.id
          }
        }).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.code === 1) {
            window.open(data.url, '_blank');
          } else {
            this.$Modal.error({
              title: '下载失败',
              content: data.msg
            });
          }
        }).catch((e) => {
          this.$Message.error('下载失败, 请重试!');
          console.log(e);
        });
        document.body.click();
      },
      shareFile(file) {
        Util.ajax.get(Util.api.file_shares, {
          params: {
            id: file.id
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.share_customers = [];
          if (res.code === 1) {
            const customers = res.data;
            customers.forEach((customer) => {
              this.share_customers.push(customer);
            });
            this.edit_file = file;
            this.set_share_config.modal = true;
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.$Message.error('获取共享信息失败, 请重试!');
          console.log(e);
        });
        document.body.click();
      },
      getFileSize(file) {
        const size = file.size || 0;
        const biggerThanMB = math.eval(`${size} / 1024 / 1024 > 1`);
        if (biggerThanMB) {
          return math.eval(`${size} / 1024 / 1024`).toFixed(1) + 'MB';
        } else {
          return math.eval(`${size} / 1024`).toFixed(1) + 'KB';
        }
      },
      searchCustomer() {
        Util.ajax.get(Util.api.query_customer_with_team, {
          params: {
            search: this.search_customer_text
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.search_customer_results = [];
          if (res.code === 1) {
            const customers = res.data;
            customers.forEach((c) => {
              this.search_customer_results.push(c);
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.$Message.error('搜索用户失败, 请重试!');
          console.log(e);
        });
      },
      addCustomerToShares(customer) {
        if (this.adding_customer) {
          return;
        }
        this.adding_customer = true;
        Util.ajax.post(Util.api.add_customer_to_file, {
          file_id: this.edit_file.id,
          customer_id: customer.id
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.adding_customer = false;
          if (data.code === 1) {
            this.share_customers.unshift(customer);
            this.edit_file.share_qty++;
          } else {
            this.$Modal.error({
              title: '提示',
              content: data.msg
            });
          }
        }).catch((e) => {
          this.adding_customer = false;
          this.$Message.error('添加共享用户失败, 请重试!');
          console.log(e);
        });
      },
      deleteCustomerFromShares(customer, index) {
        if (this.deleting_customer) {
          return;
        }
        this.$Modal.confirm({
          title: '提示',
          content: `你确定要删除 ${customer.account} 吗?`,
          onOk: () => {
            this.deleting_customer = true;
            Util.ajax.post(Util.api.delete_customer_from_file, {
              file_id: this.edit_file.id,
              customer_id: customer.id
            }).then((response) => {
              return response.data;
            }).then((data) => {
              console.log(data);
              this.deleting_customer = false;
              if (data.code === 1) {
                this.share_customers.splice(index, 1);
                this.edit_file.share_qty--;
              } else {
                this.$Modal.error({
                  title: '提示',
                  content: data.msg
                });
              }
            }).catch((e) => {
              this.deleting_customer = false;
              this.$Message.error('添加共享用户失败, 请重试!');
              console.log(e);
            });
          }
        });
      }
    }
  }
</script>
